import { Stack, Typography } from '@mui/material'
import { IconCover } from '$common/icon-cover/icon-cover'

export function ActionButton({
  children,
  text,
  onClick,
}: {
  children: JSX.Element
  text: string
  onClick: () => unknown
}) {
  return (
    <Stack sx={{ height: '82px', alignItems: 'center' }} onClick={onClick}>
      <IconCover size={50} isButton>
        {children}
      </IconCover>
      <Typography sx={{ marginTop: '8px' }} variant="body2" color="black">
        {text}
      </Typography>
    </Stack>
  )
}
